export default "__VITE_ASSET__DX4FuAFZ__"